import React, { useEffect } from "react";

import { BannerContainer } from "./Banner.styles";

interface BannerProps {
  height: number;
  id?: string;
  isFixed?: boolean;
  children: React.ReactNode;
}

/**
 * Banner component for displaying notifications at the top of the page.
 * Sets the --bannerHeight CSS custom property for use by other components.
 */
const Banner: React.FC<BannerProps> = ({ height, id, isFixed = true, children }) => {
  useEffect(() => {
    // Only offset the rest of the layout when the banner is fixed.
    const value = isFixed ? `${height}px` : "0px";
    document.documentElement.style.setProperty("--bannerHeight", value);

    return () => {
      document.documentElement.style.removeProperty("--bannerHeight");
    };
  }, [height, isFixed]);

  return (
    <BannerContainer id={id} $height={height} $isFixed={isFixed}>
      {children}
    </BannerContainer>
  );
};

export default Banner;
